import React from "react";
import Slider from "react-slick";
import ghanshyam from "./assets/image/profile-ghanshyam.jpg";
import Harshad from "./assets/image/Harshad.jpg";
import deep from "./assets/image/deep.jpg";
import kenil from "./assets/image/kenil.jpg";
import coma from "./assets/image/coma.png";
import Harshit from "./assets/image/Harshit.jpg";
import Jeel from "./assets/image/jeel.jpg";
// import Darshil from "./assets/image/darshil.jpg";

const teamMembers = [
    {
        name: "Ghanshyam Kumbhani",
        role: "Founder & CEO",
        image: ghanshyam,
        description:
            "Ghanshyam Kumbhani is the visionary founder and CEO of Liontouch webpark Innovations, a pioneering company specializing in cutting-edge web development using the MERN stack. With a passion for technology and innovation, ghanshyam has established himself as a leader in the web development industry.",
    },
    {
        name: "Harshad Domadiya",
        role: "Manager",
        image: Harshad,
        description:
            "Our Marketing Manager is a strategic leader with expertise in digital marketing, market analysis, and campaign development. They drive brand growth, enhance customer engagement, and align marketing efforts with the company's vision.",
    },
    {
        name: "Deep Bhesdadiya",
        role: "Flutter Developer",
        image: deep,
        description:
            "I have Flutter Developer with 1.5+ years of experience,who is comfortable working with android,ios and other platforms with responsive and attrective ui design to deliver exceptional customer experience. and have other skills like Firebase, sqlite..",
    },
    {
        name: "Kenil Vaghasiya",
        role: "MERN Stack Developer",
        image: kenil,
        description:
            "I am a ReactJs developer with polished skills in all of its major libraries such as React-Redux, React Router, Ant design, Material UI, etc. I have also a strong grip over React Hooks. I have developed several websites. I am also a NodeJs developer.",
    },
    {
        name: "Harshit Ramani",
        role: "Digital Marketing",
        image: Harshit,
        description:
            "A results-driven Digital Marketer and Graphic Designer skilled in creating online strategies, social media management, SEO, and content creation. Passionate about crafting impactful visuals to enhance brand presence and drive engagement.",
    },
    // {
    //     name: "Darshil Dhanani",
    //     role: "Social Media Handler",
    //     image: Darshil,
    //     description:
    //         "Our Social Media and Marketing Manager is a results-driven professional with expertise in creating and executing impactful digital strategies. With a keen understanding of audience engagement and brand growth, they ensure optimal online presence and consistent marketing success.",
    // },
     {
        name: "Jeel Pansheriya",
        role: "Bekend Developer",
        image: Jeel,
        description:
            "Experienced in building RESTful APIs using Express.js and managing MongoDB and Firebase. Skilled in JWT authentication, third-party integrations, and backend systems focused on security, scalability, and performance.",
    },
];

const Team = () => {
    var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        arrows: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    dots: true,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return (
        <section className="py-4 px-3 bg-white">
            <div className="container px-0">
                <div className="row text-center">
                    <h2 className="text-dark pb-3 fw-semibold">Our Team</h2>
                    <p>
                        Meet our dedicated team bringing innovation and expertise to every
                        project!
                    </p>
                </div>
                <div className="col-lg-12">
                    <Slider {...settings}>
                        {teamMembers.map((member, index) => (
                            <div key={index} className="p-2">
                                <div className="shadow-box p-4 m-2 d-flex flex-column h-100">
                                    <div className="d-flex justify-content-between">
                                        <div className="testimonial-info d-flex align-items-center">
                                            <img
                                                src={member.image}
                                                className="rounded-circle me-2"
                                                style={{ width: "70px", height: "70px" }}
                                                alt={member.name}
                                            />
                                            <div className="meta">
                                                <h6 className="mb-1">{member.name}</h6>
                                                <p className="text-muted">{member.role}</p>
                                            </div>
                                        </div>
                                        <div className="quote">
                                            <img src={coma} alt="Quote Icon" width="25" />
                                        </div>
                                    </div>
                                    <div className="content mt-3 flex-grow-1">
                                        <p className="text-muted">{member.description}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </Slider>
                </div>
            </div>
        </section>
    );
};

export default Team;
